import { useMe } from "../../lib/me";
import { PageHeader } from "../../ui";
import { useNow, useTasks } from "../tasks/use-tasks";
import { LinksSection } from "./LinksSection";
import { SummaryTable } from "./SummaryTable";
import { TodayPanel } from "./TodayPanel";

/** A workspace's landing screen: counts, today's work, and link tiles (architecture §1). */
export function DashboardPage({ workspaceId }: { workspaceId: string }) {
  const me = useMe();
  const now = useNow();
  const tasks = useTasks(workspaceId, "open");
  const ws = me.workspaces.find((w) => w.id === workspaceId);
  const name = ws === undefined ? "Workspace" : ws.name;

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Dashboard" />
      <div className="grid gap-6 lg:grid-cols-2">
        <SummaryTable workspaces={me.workspaces} />
        <TodayPanel workspaceId={workspaceId} tasks={tasks} now={now} />
      </div>
      <LinksSection
        scope={{ kind: "workspace", workspaceId }}
        title={`${name} links`}
        description={ws?.name === "Personal" ? "Links in your Personal workspace." : "Shared with everyone in this workspace."}
      />
      <LinksSection scope={{ kind: "me" }} title="My links" description="Only you see these, in every workspace." />
    </div>
  );
}
